import { Component, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderDataProvider } from 'libs/core/src/lib/data-provider/order.data-provider';
import { ENVIRONMENT_TOKEN } from 'libs/core/src/public-api';
import { OrderStateService } from 'libs/core/src/lib/state/order.state.service';
import { ScreenDataProvider } from 'libs/core/src/lib/data-provider/screen.data-provider';
import { NavigationHelperService } from 'libs/core/src/lib/service/navigation/navigation-helper.service';
import { ScreeningDataProvider } from 'libs/core/src/lib/data-provider/screening.data-provider';
import { SalesDocumentDataProvider } from 'libs/core/src/lib/data-provider/sales-document.data-provider';
import { CountdownComponentService } from 'libs/core/src/lib/service/countdown.service';
import { CinemaDataProvider } from 'libs/core/src/lib/data-provider/cinema.data-provider';
import { VoucherService } from 'libs/core/src/lib/service/voucher.service';
import { CateringService } from 'libs/core/src/lib/service/catering/catering.service';
import { OrderCateringService } from 'libs/core/src/lib/service/catering/order-catering.service';
import { BasketDataProvider } from 'libs/core/src/lib/data-provider/basket.data-provider';
import { AppService } from 'libs/core/src/lib/service/app.service';
import { CateringStateService } from 'libs/core/src/lib/state/catering.state.service';
import { AnalyticsHelperService } from 'libs/core/src/lib/service/analytics-helper.service';
import { BackgroundService } from 'libs/core/src/lib/service/background.service';
import { TranslationService } from 'libs/core/src/lib/service/translation.service';
import { GoogleTagManagerService } from 'libs/core/src/lib/service/analytics-services/google-tag-manager.service';
import { LoaderService } from 'libs/core/src/lib/service/loading.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FlowService } from 'libs/core/src/lib/service/flow.service';
import { UserDataProvider } from 'libs/core/src/lib/data-provider/user.data-provider';
import { AuthStateService } from 'libs/core/src/lib/state/auth.state.service';
import { ErrorHandlerService } from 'libs/core/src/lib/service/error-handler/error-handler.service';
import { ScreenStateService } from 'libs/core/src/lib/state/screen.state.service';
import { TitleService } from 'libs/core/src/lib/service/title.service';

@Component({
  template: ''
})
export class OrderSummaryBasePageComponent {
  private _router: Router;
  private _route: ActivatedRoute;
  private _orderDataProvider: OrderDataProvider;
  private _orderStateService: OrderStateService;
  private _screenDataProvider: ScreenDataProvider;
  private _navigationHelper: NavigationHelperService;
  private _screeningDataProvider: ScreeningDataProvider;
  private _salesDocumentDataProvider: SalesDocumentDataProvider;
  private _countdownComponentService: CountdownComponentService;
  private _cinemaDataProvider: CinemaDataProvider;
  private _voucherService: VoucherService;
  private _cateringService: CateringService;
  private _orderCateringService: OrderCateringService;
  private _basketDataProvider: BasketDataProvider;
  private _appService: AppService;
  private _cateringStateService: CateringStateService;
  private _analyticsHelperService: AnalyticsHelperService;
  private _backgroundService: BackgroundService;
  private _screenStateService: ScreenStateService;
  private _translationService: TranslationService;
  private _googleTagManagerService: GoogleTagManagerService;
  private _loaderService: LoaderService;
  private _modalService: BsModalService;
  private _flowService: FlowService;
  private _userDataProvider: UserDataProvider;
  private _authStateService: AuthStateService;
  private _errorHandlerService: ErrorHandlerService;
  private _titleService: TitleService;

  constructor(protected injector: Injector) {}

  protected get environment(): any {
    return this.injector.get(ENVIRONMENT_TOKEN);
  }

  protected get router(): Router {
    return (this._router ??= this.injector.get(Router));
  }

  protected get route(): ActivatedRoute {
    return (this._route ??= this.injector.get(ActivatedRoute));
  }

  protected get navigationHelper(): NavigationHelperService {
    return (this._navigationHelper ??= this.injector.get(NavigationHelperService));
  }

  protected get flowService(): FlowService {
    return (this._flowService ??= this.injector.get(FlowService));
  }

  protected get orderDataProvider(): OrderDataProvider {
    return (this._orderDataProvider ??= this.injector.get(OrderDataProvider));
  }

  protected get orderStateService(): OrderStateService {
    return (this._orderStateService ??= this.injector.get(OrderStateService));
  }

  protected get basketDataProvider(): BasketDataProvider {
    return (this._basketDataProvider ??= this.injector.get(BasketDataProvider));
  }

  protected get voucherService(): VoucherService {
    return (this._voucherService ??= this.injector.get(VoucherService));
  }

  protected get salesDocumentDataProvider(): SalesDocumentDataProvider {
    return (this._salesDocumentDataProvider ??= this.injector.get(SalesDocumentDataProvider));
  }

  protected get cinemaDataProvider(): CinemaDataProvider {
    return (this._cinemaDataProvider ??= this.injector.get(CinemaDataProvider));
  }

  protected get screenDataProvider(): ScreenDataProvider {
    return (this._screenDataProvider ??= this.injector.get(ScreenDataProvider));
  }

  protected get screeningDataProvider(): ScreeningDataProvider {
    return (this._screeningDataProvider ??= this.injector.get(ScreeningDataProvider));
  }

  protected get screenStateService(): ScreenStateService {
    return (this._screenStateService ??= this.injector.get(ScreenStateService));
  }

  protected get cateringService(): CateringService {
    return (this._cateringService ??= this.injector.get(CateringService));
  }

  protected get orderCateringService(): OrderCateringService {
    return (this._orderCateringService ??= this.injector.get(OrderCateringService));
  }

  protected get cateringStateService(): CateringStateService {
    return (this._cateringStateService ??= this.injector.get(CateringStateService));
  }

  protected get loaderService(): LoaderService {
    return (this._loaderService ??= this.injector.get(LoaderService));
  }

  protected get modalService(): BsModalService {
    return (this._modalService ??= this.injector.get(BsModalService));
  }

  protected get backgroundService(): BackgroundService {
    return (this._backgroundService ??= this.injector.get(BackgroundService));
  }

  protected get titleService(): TitleService {
    return (this._titleService ??= this.injector.get(TitleService));
  }

  protected get errorHandlerService(): ErrorHandlerService {
    return (this._errorHandlerService ??= this.injector.get(ErrorHandlerService));
  }

  protected get countdownComponentService(): CountdownComponentService {
    return (this._countdownComponentService ??= this.injector.get(CountdownComponentService));
  }

  protected get analyticsHelperService(): AnalyticsHelperService {
    return (this._analyticsHelperService ??= this.injector.get(AnalyticsHelperService));
  }

  protected get googleTagManagerService(): GoogleTagManagerService {
    return (this._googleTagManagerService ??= this.injector.get(GoogleTagManagerService));
  }

  protected get userDataProvider(): UserDataProvider {
    return (this._userDataProvider ??= this.injector.get(UserDataProvider));
  }

  protected get authStateService(): AuthStateService {
    return (this._authStateService ??= this.injector.get(AuthStateService));
  }

  protected get appService(): AppService {
    return (this._appService ??= this.injector.get(AppService));
  }

  protected get translationService(): TranslationService {
    return (this._translationService ??= this.injector.get(TranslationService));
  }
}
